<template>
  <emoji-picker @emoji="insert" :search="search" class="emoji-widget">
    
    <span
      v-if="item.icon"
      class="material-icons icon">{{ item.icon }}</span>
      
    <div
      class="emoji-widget-btn bar-button"
      slot="emoji-invoker"
      slot-scope="{ events: { click: clickEvent } }"
      @click.stop="clickEvent">
        <span v-if="item.icon" class="material-icons icon">{{ item.icon }}</span>
        <button v-else type="button">open</button>
    </div>
    <div slot="emoji-picker" slot-scope="{ emojis, insert, display }" class="emoji-widget-menu">
      <div>
        <div>
          <input type="text" v-model="search">
        </div>
        <div>
          <div v-for="(emojiGroup, category) in emojis" :key="category">
            <h5>{{ category }}</h5>
            <div>
              <span
                v-for="(emoji, emojiName) in emojiGroup"
                :key="emojiName"
                @click="append(emoji)"
                :title="emojiName"
                class="emoji-menu-item"
              >{{ emoji }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </emoji-picker>
</template>

<script>
import { EmojiPicker } from 'vue-emoji-picker'

export default {
  
  props: {
    item: Object
  },
  
  components: {
    EmojiPicker
  },
  
  computed: {},
  
  methods: {
    
    insert (emoji) {
      console.log('inserted', emoji)
    },
    
    append(emoji) {
      this.item.click(emoji);
    },
  },
  
  data () {
    
    return {
      search: '',
      input: ''
    }
  },
  
  directives: {
    
    focus: {
      inserted(el) {
        el.focus()
      }
    }
  },
};
</script>


<style scoped>
  .emoji-widget {
    position: relative;
  }
  
  .emoji-widget-menu {
    z-index: 9999;
    position: absolute;
    transform: translate(15px, 30px);
    width: 239px;
    top: 0px;
    left: 0px;
    max-height: 250px;
    background-color: #fff;
    border-radius: 10px;
    border: 1px solid #ccc;
    padding: 10px;
    overflow: hidden;
    overflow-y: auto;
    box-shadow: 0px 0px 8px 0px rgb(0 0 0 / 10%);
  }
  
  .emoji-widget-btn button {
    border: 0;
    background-color: transparent;
  }
  
  .emoji-menu-item {
    position: relative;
    display: inline-block;
    cursor: pointer;
  }
  
  .emoji-menu-item:hover {
    transform: scale(1.2);
  }
</style>
